import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import LeftBar from '../Site/LeftBar';
import ReturnContent from './ReturnContent';

import './style.css';

class ReturnDetail extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }


  constructor(props) {
    super(props);
    
    const { location } = this.props
    console.log('path: '+ location.pathname )

    var pathArray = location.pathname.split('/');
    //pathArray[1] = order
    //pathArray[2] = client id
    //pathArray[3] = order id
    
    console.log('arr: '+ pathArray)
    this.state = {
        clientId: pathArray[2],
        returnId : pathArray[3]
    };
  }

  render() {
    return (
      <div>       
        <LeftBar />
        <ReturnContent clientId={this.state.clientId} returnId={this.state.returnId} />
      </div>    


    );
  }
}

export default withRouter(ReturnDetail);